import { Box, CircularProgress, LinearProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

type InvoiceMissionProgressBarProps = {
  progressInPercent: number;
};

// Visar uppdragets framsteg i procent (0–100) medan fakturorna skapas.
export const InvoiceMissionProgressBar = (props: InvoiceMissionProgressBarProps) => {
  const { progressInPercent } = props;
  const { t } = useTranslation(['invoice']);

  const value = Math.round(Math.min(100, Math.max(0, progressInPercent || 0)));

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, width: '100%' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <CircularProgress size={16} color='success' />
        <Typography variant='body2' fontWeight={500}>
          {t('invoice:invoiceMissionPage.processing')}
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, width: '100%' }}>
        {/* Färgen kommer från temats success, inte från ett eget grönt. */}
        <LinearProgress
          variant='determinate'
          color='success'
          value={value}
          aria-label={`${value}%`}
          sx={{ flexGrow: 1, height: '0.75rem', borderRadius: '5px' }}
        />
        <Typography variant='body2' fontWeight={500} sx={{ minWidth: '3rem', textAlign: 'right' }}>
          {`${value}%`}
        </Typography>
      </Box>
    </Box>
  );
};
